import { createContext } from 'react';

const PushContext = createContext(null);

export default PushContext;
